<cs-header>
  <cs-header-title>{{ LL.nutrition.nutritionInfo() }}</cs-header-title>
</cs-header>

<cs-content>
  <cs-table style="--table-columns: 1fr auto auto">
    <cs-table-row header>
      <cs-table-header-cell>{{ LL.nutrition.labels.nutrient() }}</cs-table-header-cell>
      <cs-table-header-cell>{{ LL.nutrition.labels.target() }}</cs-table-header-cell>
      <cs-table-header-cell>{{ LL.nutrition.labels.actual() }}</cs-table-header-cell>
    </cs-table-row>

    @for (nutrient of nutrients; track nutrient) {
      <cs-table-row>
        <cs-table-cell>{{ nutrient.name }}</cs-table-cell>
        <cs-table-cell align="right">{{ formatTargetValue(nutrient) }}</cs-table-cell>
        <cs-table-cell align="right">{{ formatActualValue(nutrient) }}</cs-table-cell>
      </cs-table-row>
    }
  </cs-table>
</cs-content>
